import { memo } from 'react';

import HiddenIconSVG from '@/assets/hidden-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IHiddenIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={HiddenIconSVG} {...props} />;

export const HiddenIcon = memo(IHiddenIcon) as typeof IHiddenIcon;
